module.exports = __webpack_public_path__ + "static/media/LV2@3x.c06453c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV2@3x.png
// module id = 676
// module chunks = 0